// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"160":"b77481c4","443":"448c1381","551":"bb11a226"}[chunkId] + ".js";
};